import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";
@Entity('whatsapp_logs')

export class WhatsappLogEntity{
    @PrimaryGeneratedColumn('increment', {
        name: 'log_id'
    })
    logId:number
    @Column('varchar',{
        name:'contact_no'
    })
    contactNo:string
    @Column('varchar',{
        name:'template_name'
    })
    templateName:string
    @Column('varchar',{
        name:'created_user'
    })
    createdUser:string
    @Column('varchar',{
        name:'project_name'
    })
    projectName:string
    @Column({
        name:'genereted_at'
    })
    generetedAt:Date
    @Column("int",{
        name:'company_id'
    })
    companyId:number;
    @Column("int",{
        name:'module_id'
    })
    moduleId:number;
}